import { IStatus } from '@dfl/mui-react-common';
import { BLUE, GREEN, WARNING } from 'settings/theme';
import { DASHBOARD_THEME_COLORS } from 'modules/dashboard/constants/dashboard-colors';

export enum DISPATCH_STATUS_ENUM {
  CREATED = 'CREATED',
  REQUEST_SENT = 'REQUEST_SENT',
  PICKING_IN_PROGRESS = 'PICKING_IN_PROGRESS',
  IN_TRANSIT = 'IN_TRANSIT',
  DELIVERED = 'DELIVERED',
  ON_HOLD = 'ON_HOLD',
  COMPLETED = 'COMPLETED',
  REOPENED = 'REOPENED',
}

export const DISPATCH_STATUS: IStatus[] = [
  { _id: DISPATCH_STATUS_ENUM.CREATED, title: 'status.CREATED', color: BLUE },
  { _id: DISPATCH_STATUS_ENUM.REQUEST_SENT, title: 'status.REQUEST_SENT', color: WARNING },
  { _id: DISPATCH_STATUS_ENUM.PICKING_IN_PROGRESS, title: 'status.PICKING_IN_PROGRESS', color: WARNING },
  { _id: DISPATCH_STATUS_ENUM.IN_TRANSIT, title: 'status.IN_TRANSIT', color: WARNING },
  {
    _id: DISPATCH_STATUS_ENUM.DELIVERED,
    title: 'status.DELIVERED',
    color: DASHBOARD_THEME_COLORS.SUCCESS_COLOR,
  },
  { _id: DISPATCH_STATUS_ENUM.ON_HOLD, title: 'status.ON_HOLD', color: WARNING },
  { _id: DISPATCH_STATUS_ENUM.COMPLETED, title: 'status.COMPLETED', color: GREEN },
  { _id: DISPATCH_STATUS_ENUM.REOPENED, title: 'status.REOPENED', color: BLUE },
];

export const DISPATCH_STATUS_MAP = new Map(DISPATCH_STATUS.map((status) => [status._id, status]));

export const ALLOW_CHANGE_STATUSES: Record<DISPATCH_STATUS_ENUM, DISPATCH_STATUS_ENUM[]> = {
  [DISPATCH_STATUS_ENUM.REQUEST_SENT]: [DISPATCH_STATUS_ENUM.CREATED],

  [DISPATCH_STATUS_ENUM.PICKING_IN_PROGRESS]: [DISPATCH_STATUS_ENUM.REQUEST_SENT, DISPATCH_STATUS_ENUM.REOPENED],

  [DISPATCH_STATUS_ENUM.IN_TRANSIT]: [DISPATCH_STATUS_ENUM.PICKING_IN_PROGRESS, DISPATCH_STATUS_ENUM.REOPENED],

  [DISPATCH_STATUS_ENUM.DELIVERED]: [
    DISPATCH_STATUS_ENUM.PICKING_IN_PROGRESS,
    DISPATCH_STATUS_ENUM.IN_TRANSIT,
    DISPATCH_STATUS_ENUM.REOPENED,
  ],

  [DISPATCH_STATUS_ENUM.COMPLETED]: [DISPATCH_STATUS_ENUM.DELIVERED],

  [DISPATCH_STATUS_ENUM.ON_HOLD]: [
    DISPATCH_STATUS_ENUM.CREATED,
    DISPATCH_STATUS_ENUM.REQUEST_SENT,
    DISPATCH_STATUS_ENUM.PICKING_IN_PROGRESS,
    DISPATCH_STATUS_ENUM.IN_TRANSIT,
    DISPATCH_STATUS_ENUM.REOPENED,
  ],

  [DISPATCH_STATUS_ENUM.REOPENED]: [DISPATCH_STATUS_ENUM.ON_HOLD],

  [DISPATCH_STATUS_ENUM.CREATED]: [],
};
